import React from "react"
import { Badge } from "reactstrap"
const ReusableComponent = ({ title, value }) => {
  return (
    <>
      <div
        className={`d-flex justify-content-between ${
          title === "Leave Reason" ? "flex-column" : ""
        }`}
      >
        <div>
          <span className="fs-5 fw-semibold text-dark mt-2">{title}</span>
        </div>
        {title == "File" ? (
          value !== "" && (
            <a href={value} target="_blank" rel="noopener noreferrer">
              <Badge color="primary">Download</Badge>
            </a>
          )
        ) : (
          <div>
            <span className="fs-5 fw-normal mt-2">{value}</span>
          </div>
        )}
      </div>
    </>
  )
}
export default ReusableComponent
